import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import ByjDetails from "../components/ByjDetails";

const ByjDetailsPage = () => {
    return (
        <Layout pageTitle="苏州卫捷 | 摆药设备">
            <NavOne />
            <PageHeader title="摆药设备" />
            <ByjDetails />
            <Footer />
        </Layout>
    );
};

export default ByjDetailsPage;
